import {WindowParam} from "../../../library/context/WindowContext";
import {RowUnit} from "../../../library/atomic/unit/RowUnit";
import {SpanText} from "../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../library/basic/font";
import {SizeAttr} from "../../../library/basic/size";
import {ColumnAttr, RowAttr} from "../../../library/basic/compose";
import {SpanHoverText} from "../../../library/atomic/text/SpanHoverText";
import {ColorAttr} from "../../../library/basic/color";
import {sepLineHorizontal} from "../../../library/atomic/unit/BoxUnit";
import {ImageUnit} from "../../../library/atomic/image/ImageUnit";
import eleLicenceIcon from "../../../assets/official/ele-licence-icon-hit.png";
import {getOfficialBottomHeight} from "../compose/sizeRange";

export default function BottomFooter(wp: WindowParam) {
    let fourLine = wp.currWidth <= 720

    return (
        <RowUnit sizeAttr={new SizeAttr(wp, "100vw", getOfficialBottomHeight(wp))}
                 colorAttr={new ColorAttr(wp, "", "#f6f6f6")}
                 customStyleAttr={Object.assign({"letterspacing": "4%"}, {"flexDirection": "column"})}
                 fontAttr={new FontAttr(wp, "14px", "500", "\"PingFang Sc\"")}>
            <RowUnit
                fontAttr={new FontAttr(wp, fourLine ? "12px" : "")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                    {
                        "marginLeft": SizeAttr.changeVwToPx(wp, "9.22vw"),
                        "marginRight": "auto",
                        "transform": "translateY(4px)",
                        "flexDirection": fourLine ? "column" : "row"
                    })}>
                <SpanText
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                        {"marginRight": fourLine ? SizeAttr.changeVwToPx(wp, "9.22vw") : "94px", "marginBottom": fourLine ? "4px" : ""})}>
                    @2025 珠海煜明数字科技有限公司 版权所有
                </SpanText>
                <RowUnit
                    customStyleAttr={RowAttr.getChildrenPositionObj()}>
                    <SpanHoverText
                        onClick={() => {
                            window.location.href = "privacypolicy"
                        }}
                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                            {"marginRight": "24px"})}>
                        隐私政策
                    </SpanHoverText>
                    <SpanHoverText
                        onClick={() => {
                            window.location.href = "useragreement"
                        }}
                        customStyleAttr={RowAttr.getChildrenPositionObj()}>
                        使用条款
                    </SpanHoverText>
                </RowUnit>
            </RowUnit>
            {sepLineHorizontal(wp, "0.5px", "rgba(0, 0, 0, 0.7)", SizeAttr.changeVwToPx(
                wp, "81.56vw"), ColumnAttr.getChildrenPositionObj())}
            <RowUnit
                fontAttr={new FontAttr(wp, "12px")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                    {
                        "marginRight": SizeAttr.changeVwToPx(wp, "9.22vw"),
                        "marginLeft": SizeAttr.changeVwToPx(wp, "9.22vw"),
                        "marginTop": "18px",
                        "flexDirection": fourLine ? "column" : "row"
                    }, fourLine ? {"justifyContent": ""} : {})}>
                <SpanText
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                        {
                            "marginRight": "24px",
                            "marginBottom": fourLine ? "4px" : ""
                        }, fourLine ? {"justifyContent": ""} : {})}>
                    App备案号：粤ICP备2025386812号-3A
                </SpanText>
                <SpanText
                    customStyleAttr={Object.assign(Object.assign(RowAttr.getChildrenPositionObj(), {
                            "marginRight": "24px",
                            "marginBottom": fourLine ? "4px" : ""
                        }),
                        fourLine ? {
                            "justifyContent": ""
                        } : {})}
                >
                    粤ICP备2025386812号-1
                </SpanText>
            </RowUnit>

            <RowUnit
                fontAttr={new FontAttr(wp, "12px")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                    {
                        "marginTop": "4px",
                        "marginBottom": "auto",
                        "marginRight": SizeAttr.changeVwToPx(wp, "9.22vw"),
                        "marginLeft": SizeAttr.changeVwToPx(wp, "9.22vw"),
                        "transform": "translateX(-4px)"
                    }, fourLine ? {"justifyContent": ""} : {})}
            >
                <ImageUnit
                    onClick={() => {
                        // window.open("https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020240218131045000011716163-SAIC_SHOW_310000-2c984b4c8e31c30a018ea0742f771db1276&signData=MEUCIQDgyURoUKzhW6phymVNsDwMoerm0TxjyTTlwMAp7zIpqQIgd9tN4D7aTnTUiI8eJLbFtESOq7f9pkXXuhbp1gdoc1U=")
                    }}
                    customStyleAttr={RowAttr.getChildrenPositionObj()}
                    sizeAttr={new SizeAttr(wp, "24.8px", "29.6px")}
                    url={eleLicenceIcon}/>

                <SpanHoverText
                    onClick={() => {
                        window.location.href = "businesslicense"
                    }}
                    customStyleAttr={Object.assign(Object.assign(RowAttr.getChildrenPositionObj(), {
                            "marginLeft": "12px",
                        }),
                        fourLine ? {
                            "justifyContent": ""
                        } : {})}
                >
                    营业执照：91440400MAEC1E971N
                </SpanHoverText>
            </RowUnit>
        </RowUnit>
    )
}